import { createContext } from 'react'

export const DogsLandingsContext = createContext()
